/* eslint-disable no-param-reassign */
/* eslint-disable indent */
import React from 'react';
import { Chip, Grid, makeStyles, TextField } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import clsx from 'clsx';
import Loading from 'components/Loading';
import { cyrb53Hash, regexExp } from 'utils/helpers';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface Props {
  disabled?: boolean;
  value: string[];
  loading?: boolean;
  onChange: (value: string[]) => void;
  onError: (error: boolean) => void;
}

const AllowList = ({ disabled, value, loading, onChange, onError }: Props) => {
  const classes = useStyles();

  const [hasError] = React.useState(false);
  const [defaultValue, setDefaultValue] = React.useState<string[]>([]);

  const handleChange = (newValues: string[]) => {
    const uniqueValues = newValues?.filter(
      (value, index) => newValues?.indexOf(value) === index
    );

    onChange(uniqueValues);
    setDefaultValue(uniqueValues);
  };

  const handleRemove = (value: string) => {
    const newValue = defaultValue?.filter(item => item !== value);
    handleChange(newValue);
  };

  const renderTags = (values: string[]) => {
    if (values?.length === 0) return <></>;

    const tags = values.map((label: string) => ({
      label,
      isValidIP: true,
    }));

    return tags.map((option: { label: string; isValidIP: boolean }) => (
      <Chip
        key={cyrb53Hash(option.label)}
        classes={
          !option.isValidIP
            ? {
                outlined: classes.chipError,
                icon: classes.chipIcon,
                deleteIcon: classes.chipDeleteIcon,
              }
            : {}
        }
        icon={!option.isValidIP ? <WarningIcon fontSize="small" /> : <></>}
        variant="outlined"
        label={option.label}
        onDelete={() => handleRemove(option.label)}
      />
    ));
  };

  const handleInputChange = event => {
    const value = event.target.value.trim();

    if (event.key === 'Enter' && value !== '') {
      const newValues = value
        .split(/[,; ]+/)
        .filter(ip => regexExp.numbersDotsBarsOnly.test(ip));

      handleChange([...defaultValue, ...newValues]);
      event.target.value = '';
    }
  };

  function handleOnBlurChange(event) {
    const value = event.target.value.trim();

    if (value !== '') {
      const newValues = value
        .split(/[,; ]+/)
        .filter(ip => regexExp.numbersDotsBarsOnly.test(ip));

      handleChange([...defaultValue, ...newValues]);
      event.target.value = '';
    }
  }

  React.useEffect(() => {
    onError(hasError);
  }, [onError, hasError]);

  React.useEffect(() => {
    if (value) {
      setDefaultValue(value);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return loading ? (
    <Loading />
  ) : (
    <Grid data-testid={'autosky-allowlist'} style={{ width: '100%' }}>
      <TextField
        disabled={disabled}
        fullWidth
        id="allow-list"
        placeholder={defaultValue.length <= 0 ? '000.000.0.0' : ''}
        label={'Allow List'}
        variant="outlined"
        onBlur={handleOnBlurChange}
        className={clsx(classes.autocomplete, {
          [classes.autocompleteError]: hasError,
        })}
        InputProps={{
          startAdornment: renderTags(defaultValue),
          onKeyPress: handleInputChange,
          onChange: handleInputChange,
        }}
      />
    </Grid>
  );
};

export default AllowList;
